module.exports = __webpack_public_path__ + "static/media/avatar_default.517d7e29.PNG";